/**
 * Example book types for the landing page showcase.
 * Used by both client (gallery display) and server (admin CRUD + public API).
 */
import { z } from 'zod';

/**
 * List-level example item returned by GET /api/examples.
 * Contains just enough data for the gallery card.
 */
export const exampleListItemSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  childName: z.string(),
  childAge: z.number().int(),
  theme: z.string().nullable(),
  artStyle: z.string().nullable(),
  coverPreviewUrl: z.string().url(),
  pageCount: z.number().int(),
  bookLanguage: z.string(),
});

export type ExampleListItem = z.infer<typeof exampleListItemSchema>;

/**
 * Full example data returned by GET /api/examples/:id.
 * Includes signed page URLs for the flip-through viewer.
 */
export const examplePageDataSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  childName: z.string(),
  childAge: z.number().int(),
  theme: z.string().nullable(),
  artStyle: z.string().nullable(),
  pageUrls: z.array(z.string().url()),
  coverPreviewUrl: z.string().url(),
  pageCount: z.number().int(),
  bookLanguage: z.string(),
});

export type ExamplePageData = z.infer<typeof examplePageDataSchema>;
